import React from 'react';
import NavBar from './components/NavBar';
import LandingPage from './components/LandingPage';
import '@fortawesome/fontawesome-free/css/all.min.css';
import AlbumComponent from './components/AlbumComponent';
import '@fontsource/playfair-display'; // Defaults to weight 400
import '@fontsource/bangers';
import './App.css'; // Assuming you have a CSS file for custom styles
import VoiceDetails from './components/VoiceDetails';
import ContactMe from './components/ContactMe';
import { HashRouter, Routes, Route } from 'react-router-dom';




function App() {
  return (
    <>
    
    <HashRouter>
   
    <NavBar/>
    
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/voice-details" element={<VoiceDetails />} />
        <Route path="/demos" element={<AlbumComponent />} />
        <Route path="/contact" element={<ContactMe />} />
       
        
       

      </Routes>
     
      
    </HashRouter>
    </>
    // <div>
      
    //     <NavBar />
    //     <AlbumComponent />
    //     <LandingPage />
    //     <AudioPlayerComponent 
    //       src={demo1}
    //       title="My Narrations" 
    //       artist="Anushka Rath/ Demo" 
    //     />
    //     <VoiceDetails/>
    //     <ContactMe/>
       
       
        

        
      
    // </div>
  );
}

export default App;
